import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowclose",
  "use": "icon-arrowclose-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrowclose\">\r\n<g id=\"icon-arrowclose_&#228;&#184;&#139;&#230;&#139;&#137;&#230;&#140;&#137;&#233;&#146;&#174;\">\r\n<path id=\"icon-arrowclose_Vector 117\" d=\"M10 8L7 5L4 8\" stroke=\"#19191A\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol